import React from 'react';
import { Box, Heading, Text, VStack } from '@chakra-ui/react';
interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  tone?: 'light' | 'dark';
  align?: 'center' | 'left';
}
export function SectionHeading({
  eyebrow,
  title,
  description,
  tone = 'light',
  align = 'center'
}: SectionHeadingProps) {
  const isDark = tone === 'dark';
  return <VStack spacing={4} textAlign={align} align={align === 'center' ? 'center' : 'flex-start'} maxW="46rem" mx={align === 'center' ? 'auto' : 0} data-id="element-160" data-mp="bkn8h9igpzq2">
      {eyebrow && <Text fontSize="xs" fontWeight={600} letterSpacing="0.24em" textTransform="uppercase" color={isDark ? 'gold.300' : 'gold.600'} data-id="element-161" data-mp="1v3m3tvjjnqg">
          {eyebrow}
        </Text>}
      <Heading as="h2" fontSize={{
      base: '1.75rem',
      md: '2.5rem'
    }} color={isDark ? 'cream.50' : 'plum.800'} data-id="element-162" data-mp="uhodguc0nzu0">
        {title}
      </Heading>
      <Box w="3.5rem" h="1px" bg="gold.400" opacity={0.8} data-id="element-163" data-mp="1t9615hwdaxd0" />
      {description && <Text fontSize={{
      base: 'md',
      md: 'lg'
    }} color={isDark ? 'plum.100' : 'plum.600'} data-id="element-164" data-mp="1obe98nvq3b8t">
          {description}
        </Text>}
    </VStack>;
}